<template>
  <div @click="starTagging">
    <span
      ><star-rating
        :increment="starRatingIncrementValue"
        :max-rating="starRatingMaxRatingValue"
        :inactive-color="starRatingInactiveColor"
        :active-color="starRatingActiveColor"
        :star-size="starRatingStarSize"
        :rating="rating"
        :read-only="true"
        :show-rating="false"
      >
      </star-rating>
    </span>
    <span class="count__css">{{ rating }}/5 ({{ counts }} {{ reviewText }})</span>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating';

export default {
  name: 'star-ratings',
  components: {
    StarRating,
  },
  props: {
    starRatingIncrementValue: {
      type: Number,
      required: true,
    },
    starRatingMaxRatingValue: {
      type: Number,
      required: true,
    },
    starRatingInactiveColor: {
      type: String,
      required: true,
    },
    starRatingActiveColor: {
      type: String,
      required: true,
    },
    starRatingStarSize: {
      type: Number,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    counts: {
      type: Number,
      required: false,
    },
    starRatingsTaging: {
      type: Object,
      required: false,
    },
    reviewText: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      overallRating: this.rating,
    };
  },
  methods: {
    starTagging() {
      dataLayer.push({
        Ecommerce: this.starRatingsTaging.Ecommerce,
        event: this.starRatingsTaging.event,
        eventAction: this.starRatingsTaging.eventAction,
        eventCategory: this.starRatingsTaging.eventCategory,
        eventLabel: this.starRatingsTaging.eventLabel,
      });
      window.eventBus.$emit('kerastaseRatingsTabEnable');
    },
  },
};
</script>
